import React, { useState, useRef, useCallback } from 'react';
import {
  Box,
  TextField,
  IconButton,
  CircularProgress,
  Tooltip
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import SpeechToText from '../../SpeechToText';

const AasInputBar = ({ onSend, loading, disabled }) => {
  const [text, setText] = useState('');
  const inputRef = useRef(null);

  const handleSend = useCallback(() => {
    const trimmed = text.trim();
    if (!trimmed || loading || disabled) return;
    onSend(trimmed);
    setText('');
    setTimeout(() => inputRef.current?.focus(), 50);
  }, [text, loading, disabled, onSend]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  }, [handleSend]);

  const isDisabled = loading || disabled;

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.75, p: 1, borderTop: '1px solid #e0e0e0' }}>
      <TextField
        inputRef={inputRef}
        fullWidth
        multiline
        maxRows={4}
        size="small"
        placeholder={loading ? 'AAS is investigating...' : 'Ask AAS to investigate...'}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isDisabled}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
      />
      <SpeechToText
        onTranscript={(transcript) => {
          const newValue = text ? `${text} ${transcript}` : transcript;
          setText(newValue);
          inputRef.current?.focus();
        }}
        disabled={isDisabled}
        continuous={false}
        showInterimText={false}
      />
      <Tooltip title="Send">
        <span>
          <IconButton
            color="primary"
            onClick={handleSend}
            disabled={!text.trim() || isDisabled}
            size="small"
            sx={{
              bgcolor: 'primary.main',
              color: 'white',
              width: 34,
              height: 34,
              '&:hover': { bgcolor: 'primary.dark' },
              '&:disabled': { bgcolor: 'grey.300', color: 'grey.500' }
            }}
          >
            {loading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : <SendIcon sx={{ fontSize: 18 }} />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default AasInputBar;
